/* eslint-disable @typescript-eslint/no-explicit-any */
export type Props = {
    items: any[]
    moneyThousandsSeparator?: '.' | ','
    moneyDecimalSeparator?: '.' | ','
    limitedHeight?: boolean
    sortedColumns?: string[]
    showFixingColumnIcon?: boolean
    emptyDescription?: string
}

export interface IDinamicTableHeader {
    key: string
    label: string
}

export enum ColumnType {
    number = 'number',
    string = 'string',
    money = 'money',
    date = 'date',
    other = 'other',
}
